import { useState } from "react";

const updates = [
  { date: "09月05日", tone: "bg-primary-100 text-primary-700", dot: "bg-primary-500", label: "入口更新", text: "主站首页入口已刷新，收藏本页后可直接沿用最新地址。" },
  { date: "09月03日", tone: "bg-accent-100 text-accent-800", dot: "bg-accent-500", label: "频道更新", text: "热门看点频道新增今日内容汇总，访问时优先查看该板块。" },
  { date: "08月31日", tone: "bg-secondary-200 text-secondary-800", dot: "bg-secondary-400", label: "备用维护", text: "备用通道 B 例行维护中，期间请优先使用主站或备用 A。" },
  { date: "08月28日", tone: "bg-accent-100 text-accent-800", dot: "bg-accent-500", label: "入口更新", text: "手机访问页入口已同步，扫码或收藏后即可移动端直达。" },
  { date: "08月25日", tone: "bg-secondary-200 text-secondary-800", dot: "bg-secondary-400", label: "功能说明", text: "地址收藏夹新增“复制地址”按钮，方便把链接分享或存档。" },
];

const faqs = [
  {
    q: "吃瓜17 主站入口打不开怎么办？",
    a: "主站偶尔会因网络波动暂时无法访问，属正常现象。请稍候重试，或直接切换到列表中的备用通道 A / B，即可继续进入吃瓜17 网址地址页面。",
  },
  {
    q: "这个导航页和吃瓜17 主页是什么关系？",
    a: "本页是一份把吃瓜17 常用入口与最新链接集中收录的导航入口。它本身不替代主页，而是帮你更快找到直达位置、收藏后省去搜索的收藏夹。",
  },
  {
    q: "如何把入口收进自己的书签，长期使用？",
    a: "在浏览器中按 Ctrl+D（电脑）或通过菜单把当前页加入收藏，或点页面上的“收藏本页”。需要时从收藏夹一键进入，入口有变动时留意本文档的更新动态即可。",
  },
  {
    q: "列表里的“复制地址”和“进入”有什么区别？",
    a: "“复制地址”会把对应网址复制到剪贴板，便于分享或手动粘贴；“进入”则直接在当前窗口前往该吃瓜17 入口。按你的使用习惯选择即可。",
  },
  {
    q: "移动端访问体验如何？入口会不一样吗？",
    a: "移动端建议使用“手机访问页”入口，页面针对小屏做了排版优化。收藏后直接在手机浏览器打开即可，无需额外安装或配置。",
  },
];

export default function UpdatesFaq() {
  const [active, setActive] = useState(0);

  return (
    <section id="news" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14">
        {/* 更新动态 */}
        <div>
          <span className="text-xs font-semibold tracking-widest text-primary-600">· 更新动态</span>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl font-black text-foreground-950">入口与内容，变动随时看</h2>
          <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
            常用入口与看点频道若发生变动，会集中记录在这里，刷新即可看到最新动态。
          </p>

          <ol className="mt-7 relative border-l border-secondary-200">
            {updates.map((u) => (
              <li key={u.date + u.text} className="relative pl-6 pb-6 last:pb-0">
                <span className={`absolute -left-1 top-1.5 w-2.5 h-2.5 rounded-full ${u.dot} ring-4 ring-background-50`} />
                <div className="flex items-center gap-2">
                  <span className="text-xs font-medium text-foreground-500">{u.date}</span>
                  <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium ${u.tone}`}>
                    {u.label}
                  </span>
                </div>
                <p className="mt-1.5 text-sm text-foreground-800 leading-relaxed">{u.text}</p>
              </li>
            ))}
          </ol>
        </div>

        {/* FAQ */}
        <div>
          <span className="text-xs font-semibold tracking-widest text-accent-700">· 常见问题</span>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl font-black text-foreground-950">访问吃瓜17 常见疑问</h2>
          <p className="mt-3 text-sm text-foreground-600 leading-relaxed">关于入口、收藏与访问的疑问，多数能在这里找到答案。</p>

          <div className="mt-7 space-y-3">
            {faqs.map((f, i) => {
              const isOpen = active === i;
              return (
                <div
                  key={f.q}
                  className={`rounded-xl border bg-background-100/60 overflow-hidden transition-colors ${
                    isOpen ? "border-primary-200" : "border-secondary-200/70"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setActive(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between gap-3 text-left px-5 py-4"
                  >
                    <span className="text-sm font-semibold text-foreground-950 leading-snug">{f.q}</span>
                    <i
                      className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-xl text-primary-600 shrink-0 transition-transform`}
                    />
                  </button>
                  <div
                    className={`grid transition-all duration-300 ${
                      isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">{f.a}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}